
 <div
  class="flex flex-column justify-center align-center h-100 text-center family-info"
  *ngIf="page == 'offers'"
  style="height: 500px;"
>
  

  <h1 class="para-title sorry__title">
    <span >
      <img  src="../../../assets/images/winners.svg" alt="">
    </span>
     <p>
      Congrats, We found {{ offersToShowParent.length || 3 }} offers for you
     </p>
  </h1>
 
  <div class="text-center mt-4 buttons__parent">
    <button
      type="button"
      class="ui primary button Continue"
      (click)="changeToWorkAndLoadWidget('work-form', $event)"
    >
      Continue application
    </button>
  </div>

  <!-- <div
    class="ui grid justify-center "
    style="overflow: hidden; margin: 0 auto; cursor: pointer; z-index: 30;"
  >
    <div
      *ngFor="let offer of offersToShowParent; index as i"
      class="twelve wide column myborder mt-1 addFlexBehavior"
      [class.selectedOffer]="i == selectedOffer"
      (click)="selectOffers(i)"
    >
      <p class="bolded">
        <span class="housing"> Institution: <span class="f_institution">  {{ offer?.lender }} </span> </span>
        <span class="housing">  Loan: <span class="loan_amount"> ₦{{ offer?.amount }} </span>  </span>
        <span class="housing">  Duration: <span class="duration">{{offer?.duration}}</span>  </span>
        <span class="housing"> Rate:  <span class="rate">{{ offer?.rate }}</span>  </span>
        
      </p>
     
      

    </div>

    <br>
    <button [disabled]="selectedOffer == undefined" (click)="page = 'card_tokenisation'"  class="ui button primary basic">
      Continue
    </button>
  </div> -->
</div> 





<div
  class="flex flex-column justify-center align-center h-100 text-center family-info"
  *ngIf="page == 'preambleToForms'"
>
  <h1 class="para-title">
    Give us a few seconds let us get offers for you.
  </h1>

  <div class="twelve wide column">
    <button (click)="switchToFakeSearchingPage()" class="ui button primary basic mr-3 mb-3">
      Okay
    </button>
  </div>

  <div *ngIf="spinner" class="spinner-container">
    <!-- <i class="fa fa-circle-notch fa-spin fa-3x"></i> -->
    <app-loader></app-loader>
  </div> 
</div>

<div
  class="flex flex-column justify-center align-center h-100 text-center family-info"
  *ngIf="page == 'card_tokenisation'"
>
  <h1 class="para-title">
    Thank you for submitting your statement for analysis and selecting an offer. We would like to tokenize your card to enable smooth payment 
  </h1>

  <div class="twelve wide column">
    <button (click)="insertIframeToDom()" class="ui button primary basic mr-3">
      Ok
    </button>

    <button disabled class="ui button primary basic">
      Cancel
    </button>
  </div>
</div>




<div
  class="flex flex-column justify-center align-center h-100 text-center family-info"
  *ngIf="page == 'ask_to_make_payment'"
>
  <h1 class="para-title">
    Thank you for adding your card details. Are you ready to make part-payment of your loan offer now? 
  </h1>

  <div class="twelve wide column">
    <button (click)="page = 'confirm_upfront_payment_deduction'" class="ui button primary basic mr-3">
      Yes
    </button>

    <!-- <button disabled class="ui button primary basic">
      Cancel
    </button> -->
  </div>
</div>


<div
  class="flex flex-column justify-center align-center h-100 text-center family-info"
  *ngIf="page ==  'confirm_upfront_payment_deduction'"
>
  <h1 class="para-title">
    Please confirm that we can charge your account the sum of N50000.
  </h1>

  <div class="twelve wide column">
    <button (click)="page = 'confirm_upfront_payment_deduction'" class="ui button primary basic mr-3">
      Yes, charge my card.
    </button>

    <!-- <button disabled class="ui button primary basic">
      Cancel
    </button> -->
  </div>
</div>






<div
  class="flex flex-column justify-center align-center h-100 text-center family-info"
  *ngIf="page == 'pre_bankstatement'"
>
  <h1 class="para-title">
    Thank you for filling your bank details. 
    We would like to analyse your bank statement to determine if you can pay this loan.
    Please select your preferred method for analysis. 
  </h1>

  <div class="twelve wide column">
    <button (click)="insertBSIframeIntoDOM()" class="ui button primary basic mr-3">
      Online banking
    </button>

    <button disabled class="ui button primary basic">
      Statement
    </button>
  </div>
  <div *ngIf="spinner" class="spinner-container">
    <!-- <i class="fa fa-circle-notch fa-spin fa-3x"></i> -->
    <app-loader></app-loader>
  </div> 
</div>


<div
  class="flex flex-column justify-center align-center h-100 text-center family-info"
  *ngIf="page == 'sorry-page'"
>
  <h1 class="para-title sorry__title">
    <span >
      <img  src="../../../assets/images/broken_link.svg" alt="">
    </span>
     <p>
      Sorry, we encountered some errors trying to connect to our servers!.
     </p>
  </h1>

  <div class="twelve wide column mt-3">
    <button (click)="insertIframeToDom()" class="ui button primary basic mr-3">
     Try again
    </button>

    <button class="ui button primary basic">
      cancel
    </button>
  </div>
  <div *ngIf="spinner" class="spinner-container">
    <!-- <i class="fa fa-circle-notch fa-spin fa-3x"></i> -->
    <app-loader></app-loader>
  </div> 
</div>

<div
  class="flex flex-column justify-center align-center h-100 text-center family-info"
  id="divforIframe"
  *ngIf="page == 'iframe_container'"
>
      <div *ngIf="spinner" class="spinner-container">
        <!-- <i class="fa fa-circle-notch fa-spin fa-3x"></i> -->
        <app-loader></app-loader>
      </div> 
</div>



<!-- work form -->
<div class=" h-100 text-center family-info" *ngIf="page == 'work-form'">
  <h1 class="para-title">
    Please where do you work?
  </h1>

  <app-work-form (changeUpTheViewTwo)="page = $event"></app-work-form>
</div>

<!-- Address info -->
<div class=" h-100 text-center family-info" *ngIf="page == 'address-info'">
  <h1 class="para-title">
    Please, where do you stay?
  </h1>

  <app-address-form (changeUpTheViewThree)="page = $event"></app-address-form>
</div>

<div class=" h-100 text-center family-info" *ngIf="page == 'preamble_to_bankdetails'">
  <h1 class="para-title">
    We would like to know what account your loan repayment will be debited from?
  </h1>

  <div class="twelve wide column">
    <button (click)="page = 'bank-details'" class="ui button primary basic mr-3 mb-3">
      Ok, let's go
    </button>

    <button disabled class="ui button primary basic">
      let's do this later.
    </button>
  </div>
  


</div>

<div class=" h-100 text-center family-info" *ngIf="page == 'bank-details'">
  <h1 class="para-title">
   Please enter your bank details
  </h1>
  

<app-parent-account-form
 (changeUpTheViewThree)="changeUpView($event)">
</app-parent-account-form>

</div>



<!-- BVN -->
<div class=" h-100 text-center family-info" *ngIf="page == 'bvn'">
  <h1 class="para-title">
    Enter BVN
  </h1>

  <form [formGroup]="BVNFORM" class="w-100" style="position: relative">
    <div class="ui form">
      <div class="field">
        <label>BVN</label>
        <input formControlName="bvn" type="number" placeholder="22917134590" />
        
      </div>
    </div>
<!--    (click)="page = 'valid-id'" -->
    <div class="text-center mt-4">
      <button
        type="button"
        class="ui primary button fluid"
        (click)="submitParentBVN(BVNFORM)"
        [disabled]="!BVNFORM.valid"
      >
        Continue
      </button>
    </div>
    <div *ngIf="spinner" class="spinner-container">
      <!-- <i class="fa fa-circle-notch fa-spin fa-3x"></i> -->
      <app-loader></app-loader>
    </div>
  </form>
</div>

<!-- Means of identification -->





<div
  class=" h-100 text-center family-info"
  *ngIf="page == 'checking'"
>
  <h1 class="para-title">
    Searching for offers for you...
  </h1>
  <p class="para-body mt-3">
    <svg
      width="73px"
      height="88px"
      viewBox="0 0 73 88"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <g id="hourglass">
        <path
          d="M63.8761664,86 C63.9491436,84.74063 64,83.4707791 64,82.1818182 C64,65.2090455 57.5148507,50.6237818 48.20041,44 C57.5148507,37.3762182 64,22.7909545 64,5.81818182 C64,4.52922091 63.9491436,3.25937 63.8761664,2 L10.1238336,2 C10.0508564,3.25937 10,4.52922091 10,5.81818182 C10,22.7909545 16.4851493,37.3762182 25.79959,44 C16.4851493,50.6237818 10,65.2090455 10,82.1818182 C10,83.4707791 10.0508564,84.74063 10.1238336,86 L63.8761664,86 Z"
          id="glass"
          fill="skyblue"
        ></path>
        <rect
          id="top-plate"
          fill="#0a263b"
          x="0"
          y="0"
          width="74"
          height="8"
          rx="2"
        ></rect>
        <rect
          id="bottom-plate"
          fill="#0a263b"
          x="0"
          y="80"
          width="74"
          height="8"
          rx="2"
        ></rect>

        <g id="top-sand" transform="translate(18, 21)">
          <clipPath id="top-clip-path" fill="white">
            <rect x="0" y="0" width="38" height="21"></rect>
          </clipPath>

          <path
            fill="#afddff"
            clip-path="url(#top-clip-path)"
            d="M38,0 C36.218769,7.51704545 24.818769,21 19,21 C13.418769,21 1.9,7.63636364 0,0 L38,0 Z"
          ></path>
        </g>

        <g id="bottom-sand" transform="translate(18, 55)">
          <clipPath id="bottom-clip-path" fill="white">
            <rect x="0" y="0" width="38" height="21"></rect>
          </clipPath>

          <g clip-path="url(#bottom-clip-path)">
            <path
              fill="#afddff"
              d="M0,21 L38,21 C36.1,13.3636364 24.581231,0 19,0 C13.181231,0 1.781231,13.4829545 0,21 Z"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  </p>

    <!-- <p class="para-title" style="text-align: center;">
        Searching for offers for you...
      </p> -->
</div>

  <!-- (click)="changeToWorkAndLoadWidget('work-form')"  -->

  <div
  class="flex flex-column justify-center align-center h-100 text-center family-info"
  *ngIf="page == 'verify-data'"
  >
  <app-verify-parent-data
    [fromBankPartnership]="informationForVerifyComp"
    (parentHasVerifiedEmail)="continueToDataWidget()"></app-verify-parent-data>
</div>


<div
  class=" h-100 text-center family-info"
  *ngIf="page == 'notify-school'"
>
  <h1 class="para-title">
    Please wait while we notify your school to review your request...
  </h1>
  <p class="para-body mt-3">
    <svg
      width="73px"
      height="88px"
      viewBox="0 0 73 88"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <g id="hourglass">
        <path
          d="M63.8761664,86 C63.9491436,84.74063 64,83.4707791 64,82.1818182 C64,65.2090455 57.5148507,50.6237818 48.20041,44 C57.5148507,37.3762182 64,22.7909545 64,5.81818182 C64,4.52922091 63.9491436,3.25937 63.8761664,2 L10.1238336,2 C10.0508564,3.25937 10,4.52922091 10,5.81818182 C10,22.7909545 16.4851493,37.3762182 25.79959,44 C16.4851493,50.6237818 10,65.2090455 10,82.1818182 C10,83.4707791 10.0508564,84.74063 10.1238336,86 L63.8761664,86 Z"
          id="glass"
          fill="skyblue"
        ></path>
        <rect
          id="top-plate"
          fill="#0a263b"
          x="0"
          y="0"
          width="74"
          height="8"
          rx="2"
        ></rect>
        <rect
          id="bottom-plate"
          fill="#0a263b"
          x="0"
          y="80"
          width="74"
          height="8"
          rx="2"
        ></rect>

        <g id="top-sand" transform="translate(18, 21)">
          <clipPath id="top-clip-path" fill="white">
            <rect x="0" y="0" width="38" height="21"></rect>
          </clipPath>

          <path
            fill="#afddff"
            clip-path="url(#top-clip-path)"
            d="M38,0 C36.218769,7.51704545 24.818769,21 19,21 C13.418769,21 1.9,7.63636364 0,0 L38,0 Z"
          ></path>
        </g>

        <g id="bottom-sand" transform="translate(18, 55)">
          <clipPath id="bottom-clip-path" fill="white">
            <rect x="0" y="0" width="38" height="21"></rect>
          </clipPath>

          <g clip-path="url(#bottom-clip-path)">
            <path
              fill="#afddff"
              d="M0,21 L38,21 C36.1,13.3636364 24.581231,0 19,0 C13.181231,0 1.781231,13.4829545 0,21 Z"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  </p>

    <!-- <p class="para-title" style="text-align: center;">
        Searching for offers for you...
      </p> -->
</div>

